<template>
    <Heading>{{ $t("Change email") }}</Heading>

    <form @submit.prevent="submit" class="sm:w-1/2">
        <FormInput v-model="form.new_email" :error="form.errors.new_email" :label="$t('New email')" name="new_email"
                   type="email" icon="fa-solid fa-key" class="mb-6"/>
        <Button ref="button" :disabled="form.processing">{{ $t("Change email") }}</Button>
    </form>
</template>


<script setup>
import FormInput from "@/Shared/FormInput";
import Button from "@/Shared/Button";
import Heading from "@/Shared/Heading";
import {useForm} from "@inertiajs/inertia-vue3";
import {ref} from "vue";

const form = useForm({
    new_email: null
})

const button = ref(null);

function submit() {
    button.value.toggleLoading();
    form.post(route('user.change_email'), {
        preserveScroll: true,
        onError: () => button.value.toggleLoading()
    })
}
</script>
